import { useLocation } from "react-router-dom";

// ----------------------------------------------------------------------

export function useHash() {
    const { hash } = useLocation();
    return hash;
}
